import { FormControlError, FormGroup, FormLabel, Placeholder, Switch } from '@hai/ui-react';
import { useField } from 'formik';
import React from 'react';

interface Props {
  name: string;
  title?: string;
  disabled?: boolean;
  switchLabel?: string;
  required?: boolean;
  labelPlacement?: 'left' | 'right';
  loading?: boolean;
  controlProps?: any;
  className?: string;
  visibilityHidden?: boolean;
  height?: string;
  checked?: boolean;
  onSwitchText?: string;
  offSwitchText?: string;
  onChange?: (value: any) => any;
}

export const FormikSwitch: React.FunctionComponent<Props> = ({
  title,
  name,
  disabled,
  required,
  labelPlacement = 'left',
  loading,
  switchLabel,
  className,
  visibilityHidden,
  height,
  checked,
  onSwitchText,
  offSwitchText,
  onChange,
}) => {
  const [, meta, helper] = useField(name);
  const hasErrors = meta.error && meta.touched;
  const value = meta.touched ? meta.value : meta.initialValue;

  let additionalClassNames = className ? ` ${className}` : '';
  let additionalSwitchClassNames = '';
  if (visibilityHidden) {
    additionalClassNames += ' invisible';
  }

  if (height === 'short') {
    additionalSwitchClassNames += ' short';
  }

  return (
    <FormGroup className={`FormItem${additionalClassNames}`}>
      {title && <FormLabel required={required}>{title}</FormLabel>}
      {loading === true ? (
        <div className="mk-switch-placeholder-label">
          <div>{switchLabel}</div>
          <Placeholder as="layout" />
        </div>
      ) : (
        <Switch
          className={additionalSwitchClassNames}
          checked={checked ?? value}
          onChange={(newValue: boolean) => {
            helper.setTouched(true);
            helper.setValue(newValue);
            onChange?.(newValue);
          }}
          label={switchLabel}
          disabled={disabled}
          onSwitchText={onSwitchText}
          offSwitchText={offSwitchText}
          labelPlacement={labelPlacement}
        />
      )}
      <FormControlError show={hasErrors} mssg={meta.error} />
    </FormGroup>
  );
};
